export enum SelfEmployedType {
  Eenmanszaak = 'Eenmanszaak',
  VerenigingOnderFirma = 'VerenigingOnderFirma',
  Maatschap = 'Maatschap',
  BeslotenVennootschap = 'BeslotenVennootschap'
}
